var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,0C165.23,0,85.5,47.243,40.044,118.479l347.159,357.37C461.946,431.147,512,349.423,512,256 C512,114.616,397.384,0,256,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M512,256c0-66.422-25.298-126.93-66.783-172.428v344.857C486.702,382.93,512,322.422,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M319.789,481.873l26.815-0.017l8.272-25.509l8.302,25.499l13.45-0.008 c8.247-4.415,16.224-9.267,23.9-14.529L44.689,111.471c-5.864,8.556-11.212,17.49-16.021,26.75l3.162,9.712l26.815-0.017 l-21.684,15.775l8.302,25.499l-21.704-15.748l-12.945,9.416C3.713,206.034,0,230.583,0,256c0,141.384,114.616,256,256,256 c29.892,0,58.583-5.132,85.25-14.552L319.789,481.873z M57.099,244.87l8.27-25.508l-21.702-15.75l26.815-0.017l8.271-25.509 l8.302,25.499l26.815-0.017l-21.685,15.775l8.302,25.499l-21.704-15.748L57.099,244.87z M112.324,300.522l8.27-25.508 l-21.702-15.75l26.815-0.017l8.271-25.509l8.302,25.499l26.815-0.017l-21.684,15.775l8.302,25.499l-21.704-15.748L112.324,300.522z  M167.548,356.174l8.27-25.508l-21.702-15.75l26.815-0.017l8.271-25.509l8.302,25.499l26.815-0.017l-21.684,15.775l8.302,25.499 l-21.704-15.75L167.548,356.174z M244.457,396.051l-21.685,15.775l8.27-25.508l-21.702-15.75l26.815-0.017l8.272-25.509 l8.302,25.499l26.815-0.017l-21.684,15.775l8.302,25.499L244.457,396.051z M277.997,467.478l8.27-25.508l-21.702-15.75 l26.815-0.017l8.271-25.509l8.302,25.499l26.815-0.017l-21.684,15.775l8.302,25.499l-21.704-15.75L277.997,467.478z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/ba.efac4a2ac18e41da819176f1fd16eab0.svg";
export { ForwardRef as ReactComponent };